import * as React from "react";
import { WebsocketContext } from "./WebsocketProvider";
var ReadyCheck = function () {
    var send = React.useContext(WebsocketContext).send;
    return (React.createElement("button", { className: "big", onClick: function () {
            return confirm("Are you ready to start the game?") && send("ReadyCheck");
        } }, "Check if everyone is ready!"));
};
export default ReadyCheck;
